"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Overflow = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  root: {
    overflow: 'auto',
    height: '100%'
  }
}; // eslint-disable-next-line prefer-arrow-callback

var Overflow = _react.default.forwardRef(function Overflow(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, className),
    ref: ref
  }, children);
});

exports.Overflow = Overflow;
process.env.NODE_ENV !== "production" ? Overflow.propTypes = {
  children: _propTypes.node.isRequired,
  classes: _propTypes.object.isRequired,
  className: _propTypes.string
} : void 0;
Overflow.defaultProps = {
  className: null
};

var _default = (0, _styles.withStyles)(styles, {
  name: 'Overflow'
})(Overflow);

exports.default = _default;